<template>
    <b-modal :id="modalId" title="Bookmark" hide-footer>
        <loading-screen :is-loading="isSaving"></loading-screen>
        <errors :error-list="serverErrors"></errors>

        <!-- Form -->
        <form @submit.prevent="attemptUpdateBookmark">

            <div class="form-group mb-4">
                <label for="bookmark">Bookmark As</label>
                <input v-model="updatedBookmark" name="bookmark" id="bookmark" type="text" class="form-control" />
            </div>

            <div>
                <button type="submit" class="btn btn-itg-dark" :disabled="isSaving||!bookmarkValueProvided" @click.prevent="attemptUpdateBookmark">
                    {{ currentValue ? 'Update' : '+ Add' }} Bookmark
                </button>

                <button v-if="currentValue" type="submit" class="btn btn-itg ml-3" :disabled="isSaving" @click.prevent="removeBookmark">
                    Remove Bookmark
                </button>
            </div>

        </form>
        <!-- / Form -->
    </b-modal>
</template>

<script>
import Errors from '../../../../../components/Errors.vue';
import LoadingScreen from '../../../../../components/LoadingScreen.vue';
import Forms from '../../../../../mixins/Forms';
import axios from 'axios';
import { mapActions } from 'vuex';

export default {
    props: ['modelType', 'modelId', 'currentValue'],

    data() {
        return {
            isSaving: false,
            serverErrors: [],
            updatedBookmark: this.currentValue
        }
    },

    mixins: [Forms],

    components: {
        Errors,
        LoadingScreen
    },

    computed: {
        modalId() {
            return 'bookmark-modal-' + this.modelType + '-' + this.modelId;
        },

        bookmarkValueProvided() {
            return this.updatedBookmark && this.updatedBookmark.trim().length > 0;
        }
    },

    methods: {
        ...mapActions('ticketViewer', {
            reloadTicket: 'reloadTicket'
        }),

        attemptUpdateBookmark() {
            this.serverErrors = [];

            if (
                !this.updatedBookmark
                ||
                this.updatedBookmark.trim().length == 0
            ) {
                this.serverErrors = ['Bookmark description cannot be empty.'];
                return;
            }

            this.updateBookmark();
        },

        updateBookmark() {
            let vm = this;
            vm.serverErrors = [];
            vm.isSaving = true;

            axios.post(window.API_BASE + '/bookmark', {
                type: vm.modelType,
                id: vm.modelId,
                value: vm.updatedBookmark
            }).then(() => {
                vm.isSaving = false;
                vm.$bvModal.hide(vm.modalId);
               vm.reloadTicket(); 
            }).catch(e => {
                console.log(e);
                vm.isSaving = false;
                vm.setErrors(e);
            });
        },

        removeBookmark() {
            let vm = this;
            vm.updatedBookmark = null;
            vm.updateBookmark();
        }
    }
}
</script>

<style></style>